export const CalendarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect
      x="3"
      y="5"
      width="18"
      height="16"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M4 10H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7 3L7 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M17 3L17 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect x="7" y="13" width="4" height="2" rx="0.5" fill="currentColor" />
    <rect x="7" y="16" width="4" height="2" rx="0.5" fill="currentColor" />
    <rect x="13" y="13" width="4" height="2" rx="0.5" fill="currentColor" />
    <rect x="13" y="16" width="4" height="2" rx="0.5" fill="currentColor" />
  </svg>
);
